import React, { useEffect, useState } from "react";
import { Home, ArrowLeft } from "lucide-react";
import { getSubscriptions } from "../../lib/Subscription";

export default function BuyRenewConfirmationPage() {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscription();
  }, []);

  const fetchSubscription = async () => {
    try {
      const userId = 69; // replace with logged-in user id if needed
      const res = await getSubscriptions(userId);

      if (res?.success && res?.data?.length > 0) {
        setSubscription(res.data[0]);
      }
    } catch (error) {
      console.error("Subscription fetch error:", error);
    } finally {
      setLoading(false);
    }
  };
console.log("Response data:",subscription);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary text-xl">
        Loading subscription details...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-secondary font-sans px-4 md:px-10 py-6">
      {/* Top Header */}
      <div className="flex items-start justify-between mb-8">
        <div>
          <div className="w-[220px] h-[90px] bg-black rounded-xl flex items-center justify-center text-white text-4xl font-bold shadow-card">
            InstaED
          </div>
          <p className="text-xl md:text-2xl mt-3 text-black">
            Online Tuitions | 6-12
          </p>
        </div>

        <img
          src="https://i.pravatar.cc/60?img=32"
          alt="profile"
          className="w-14 h-14 rounded-full object-cover"
        />
      </div>

      {/* Purple Bar */}
      <div className="bg-primary rounded-lg px-6 py-5 flex items-center justify-between text-white mb-16">
        <h1 className="text-2xl md:text-3xl font-semibold">
          Buy | Renew Re-confirmation
        </h1>

        <div className="flex items-center gap-5">
          <button>
            <Home size={30} />
          </button>
          <button>
            <ArrowLeft size={30} />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-14">
          Hi, you are renewing your subscription to InstaED.
        </h2>

        <div className="space-y-8 text-lg md:text-xl">
          <InfoRow
            label="Current class"
            value={
              <div className="flex flex-wrap items-center gap-3">
                <span>Class 9</span>
                <span className="text-red-500 text-base md:text-lg">
                  (Academic year expired)
                </span>
              </div>
            }
          />

          <InfoRow
            label="Subscribing / renewing to"
            value={subscription?.className || "-"}
          />
           <InfoRow
            label="Subjects"
            value={subscription?.subjectName || "-"}
          />

          <InfoRow
            label="Plan Type"
            value={subscription?.planType || "-"}
          />

          <InfoRow
            label="Academic session"
            value={`${formatDate(subscription?.startDate)} - ${formatDate(subscription?.endDate)}`}
          />

          <InfoRow
            label="Weekdays opted"
            value={<CheckedText text={subscription?.batchType || "-"} />}
          />

          <InfoRow
            label="Payment Method opted "
            value={subscription?.paymentId || "-"}
          />
        </div>

        <div className="flex flex-col items-center mt-16 gap-5">
          <button className="bg-black text-white px-12 py-4 rounded-lg text-xl font-medium shadow-card">
            Proceed to pay
          </button>

          <button className="text-xl underline text-black/70">
            Refund policy
          </button>
        </div>
      </div>
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
      <div className="text-primary font-semibold">{label}:</div>
      <div className="text-black">{value}</div>
    </div>
  );
}

function CheckedText({ text }) {
  return (
    <div className="flex items-center gap-4">
      <div className="w-9 h-9 border-[3px] border-black rounded-sm flex items-center justify-center text-2xl font-bold">
        ✓
      </div>
      <span>{text}</span>
    </div>
  );
}

function formatDate(date) {
  if (!date) return "-";

  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}




// import React, { useEffect, useState } from "react";
// import { Home, ArrowLeft } from "lucide-react";
// import axios from "axios";

// const ReconfirmationPage = () => {
//   const [apiData, setData] = useState(null);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ FETCH DATA
//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "http://localhost:5050/LiveClasses/GetSubscriptions",
//         {
//           params: { userId: 69 },
//           headers: {
//             Authorization: `Bearer YOUR_TOKEN_HERE`, // 🔥 replace with real token
//           },
//         }
//       );

//       console.log("API RESPONSE 👉", response.data);

//       const res = response.data;

//       if (res.success && res.data.length > 0) {
//         const d = res.data[0];

//         setData({
//           id: d.id,
//           courseId: d.assignedCourseId,
//           sessionId: d.sessionId,
//           batchId: d.batchId,
//           planType: d.planType,
//           startDate: d.startDate,
//           endDate: d.endDate,
//           paymentId: d.paymentId,
//           sessionName: d.sessionName,
//           batchType: d.batchType,
//         });
//       } else {
//         console.warn("No data found ❌");
//       }
//     } catch (err) {
//       console.error("API ERROR", err);
//     }
//   };

//   // ✅ LOADING STATE
//   if (!apiData) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <p>Loading...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-[#f5f1eb]">
//       {/* HEADER */}
//       <div className="bg-[#6b57a5] text-white flex justify-between items-center px-8 py-4 rounded-md m-4">
//         <h1 className="text-lg font-semibold">
//           Buy | Renew Re-confirmation
//         </h1>

//         <div className="flex gap-6">
//           <Home className="cursor-pointer" />
//           <ArrowLeft className="cursor-pointer" />
//         </div>
//       </div>

//       {/* CONTENT */}
//       <div className="max-w-3xl mx-auto mt-16">
//         <h2 className="text-center text-xl font-semibold mb-16">
//           Hi, you are renewing your subscription to InstaED.
//         </h2>

//         <div className="space-y-6">
//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Course ID</span>
//             <span>{apiData.courseId}</span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Batch</span>
//             <span>{apiData.batchType}</span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Plan</span>
//             <span>{apiData.planType}</span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">Start Date</span>
//             <span>
//               {apiData.startDate
//                 ? new Date(apiData.startDate).toLocaleDateString()
//                 : "-"}
//             </span>
//           </div>

//           <div className="flex justify-between">
//             <span className="text-[#6b57a5] font-medium">End Date</span>
//             <span>
//               {apiData.endDate
//                 ? new Date(apiData.endDate).toLocaleDateString()
//                 : "-"}
//             </span>
//           </div>
//         </div>

//         {/* BUTTON */}
//         <div className="text-center mt-16">
//           <button className="bg-black text-white px-10 py-3 rounded-md">
//             Proceed to pay
//           </button>

//           <p className="mt-4 text-sm underline cursor-pointer">
//             Refund policy
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReconfirmationPage;